import {
    JOURNAL_VOUCHER_REPORT_REQUEST,
    JOURNAL_VOUCHER_REPORT_SUCCESS,
    JOURNAL_VOUCHER_REPORT_FAILURE
  } from "../types/journal-voucher-report-types";
  
  const initialState = {
    journalVoucherReport: {},
    loading: false,
    error: null,
  };
  
  const journalVoucherReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case JOURNAL_VOUCHER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case JOURNAL_VOUCHER_REPORT_SUCCESS: {
        return {
          ...state,
          journalVoucherReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case JOURNAL_VOUCHER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default journalVoucherReportReducer;
  